<div class="modal-content modal-content-mat-list">
    <div class="row w-90 mx-auto">
        <div class="col-sm-12">
            <button class="close mr-4 mt-4" type="button" (click)="close()"><i class="fa fa-times"></i></button>
        </div>
        <div class="col-sm-12 px-5 mb-2">
            <h1 *ngIf="title">
                {{ title || '' }}
            </h1>
        </div>
        <div class="col-sm-12 px-5 mb-2">
            <div class="row">
                <div class="col-12 mb-3 font-size" *ngFor="let item of list">
                    <mat-chip class="chip-info mr-3"><i class="fa fa-angle-right" aria-hidden="true"></i></mat-chip>
                    <strong>{{ item.label }}</strong>{{ validateRutType(item.label) ? (item.value | rutFormat) : item.value }}
                </div>
            </div>
        </div>
    </div>
</div>